import { render, staticRenderFns } from "./ModaFormPayComponent.vue?vue&type=template&id=72f49320"
import script from "./ModaFormPayComponent.vue?vue&type=script&lang=js"
export * from "./ModaFormPayComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports